import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "P1_75em",
  style: {"justify-content":"center","align-items":"center"}
}
const _hoisted_2 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_4 = { class: "D-Flex FlexCenter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesButton = _resolveComponent("CookiesButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.Translate('Catalog URL')), 1),
      _createVNode(_component_CookiesNormalInput, {
        onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.SaveMyConfig('Catalog_MainURL', _ctx.MEMRead('Catalog_MainURL')))),
        Res: 'Catalog_MainURL'
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CookiesButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/Catalogs/ViewCatalogs'))),
        class: "CookiesButton F-Bold F1_25em BGMain"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Translate('Edit Cover')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}